import React, {useState, useEffect, useRef} from "react";
import {getActiveThemeColor} from "../../../utils/utils";
import {useGlobalState} from "../../../context/global_state";
import BalloonGamePoster from "./BalloonGamePoster.comp";
import TFQSliderPoster from "./TFQSliderPoster.comp";
import Footer from "../../../components/Footer/plugable.footer";
import ReactHtmlParser from "react-html-parser";
import {DQ_THEMES, NAV_DIRECTION} from "../../../utils/constants";
import LSQSliderPoster from "./LSQSliderPoster.com";
import RazProgressSVG from "../../../components/UI/SVG_IMGs/RazProgressSVG";
import styled from "styled-components";

function getIndexOf(searchStr, str, caseSensitive, startIndex = 0) {
    let searchStrLen = searchStr.length;
    if(searchStrLen == 0)
    {
        return -1;
    }
    if (!caseSensitive) {
        str = str.toLowerCase();
        searchStr = searchStr.toLowerCase();
    }
    return str.indexOf(searchStr, startIndex);
}

function replaceKeyword(searchStr, replaceStr, parentStr, caseSensitive = false)
{
    let startIndex = 0;
    let index = -1;
    while((index = getIndexOf(searchStr, parentStr, caseSensitive, startIndex)) > -1)
    {
        const firstStr = parentStr.slice(0, index)
        const lastStr = parentStr.slice(index + searchStr.length, parentStr.length)
        parentStr = firstStr + replaceStr + lastStr
        startIndex = (firstStr + replaceStr).length;
    }
    return parentStr;
}

const QuestionPoster = (props) => {

    const { question, subtitle_top, subtitle_bottom, choices, multi_select, question_number, code, type } = props.question;
    const { answers, updateAnswers, questionNextAction, questionPrevAction
        , show_alias_keys, hide_alias_keys, nav_direction, step_skip_count_ref, enable_qa_mode
        , progress, displayNumber, totalQuestions } = props;
    const { is_ui_rules_exist, ui_rules } = props.question;
    const [ inputQuestions, setInputQuestions ] = useState([]);
    const [ unselectQuestions, setUnselectQuestions ] = useState([]);
    const [ questionHTML, setQuestionHTML ] = useState(question);
    const [ choicesHTML, setChoicesHTML ] = useState(choices);
    const [ toolTipText, setToolTipText ] = useState('');
    const [ displayTooltip, setDisplayTooltip ] = useState(false);
    const [tooltipPos, setToolTipPos ] = useState({x: 0, y: 0});
    //const [themeName, setThemeName ] = useState(props.theme.name);
    const [subtitleTopHTML, setSubtitleTopHTML] = useState(subtitle_top);

    const { profile, settings } = useGlobalState();

    const choicesDiv = useRef(null);

    // MTQ (drag-to-sort ordering question) state. `mtqOrder` holds the current
    // display order as an array of original choice indices; it's mirrored into
    // answers[question_number].selIndexes so the existing "has an answer" /
    // goNext checks in QuizTime.page.jsx (which read selIndexes) keep working
    // unchanged.
    const [ mtqOrder, setMtqOrder ] = useState([]);
    const [ mtqDraggingIdx, setMtqDraggingIdx ] = useState(null);
    const [ mtqDragOffsetY, setMtqDragOffsetY ] = useState(0);
    const [ mtqDisplacedIdx, setMtqDisplacedIdx ] = useState(null);
    const mtqItemRefs = useRef({});
    const mtqDragMetaRef = useRef(null);

    let tips_length = subtitle_top.length + subtitle_bottom.length;


    const resetAnswers = () => {
        let _answers = answers;
        _answers[question_number] = {
            code: code,
            multi_select: multi_select,
            selIndexes: [],
            selectedIndex: -1
        }
        updateAnswers(_answers);
    }

    const linkifyText = (text) => {
        if (!text) return text;
        const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        return text.replace(urlRegex, function(url) {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
    };


    useEffect( () => {
        if (!(question_number in answers)) {
            resetAnswers();
        }
        if (choicesDiv.current) {
            choicesDiv.current.scrollTop = 0;
        }

        const input_indices = []
        const unselect_indices = []
        let modified_question = question;
        let modified_choices = choices;
        let skip_this_step = false;
        // ui_rules is normally an array, but some authored instruments carry a
        // single bare rule object — normalize so .forEach never crashes.
        const ui_rules_list = Array.isArray(ui_rules)
            ? ui_rules
            : (ui_rules && typeof ui_rules === 'object' ? [ui_rules] : []);
        ui_rules_list.forEach((rule) => {
            switch(rule.type) {
                case "INDEX_EFFECT":
                    if (rule.effect === "USER_INPUT") {
                        input_indices.push(rule.index)
                    }
                    else if(rule.effect === "UNSELECT") {
                        unselect_indices.push(rule.index)
                    }
                    break;
                case "QUESTION_EFFECT":
                    if (rule.effect === "TOOLTIP") {
                        modified_question = replaceKeyword(rule.text, `<tooltip text='${rule.text}' html='${rule.html}'></tooltip>`, modified_question)
                    }
                    break;
                case "ANSWER_EFFECT":
                    if (rule.effect === "TOOLTIP") {
                        modified_choices = modified_choices.map((choice) => replaceKeyword(rule.text, `<tooltip text='${rule.text}' html='${rule.html}'></tooltip>`, choice))
                    }
                    break;
                case "ALIAS_KEY_LOOKUP":
                    if (rule.effect === "SHOW" && show_alias_keys) {
                        if (!show_alias_keys.includes(rule.alias_key)) {
                            skip_this_step = true;
                        }
                    }
                    if (rule.effect === "HIDE" && hide_alias_keys) {
                        if (hide_alias_keys.includes(rule.alias_key)) {
                            skip_this_step = true;
                        }
                    }
                    break;
                case "PRE_REQ":
                    if (rule.effect === "SHOW") {
                        const pre_req_answer = Object.values(answers).find((answer) => answer.code && answer.code.endsWith(rule.raw_data_code));
                        const pre_req_selections = pre_req_answer
                            ? (pre_req_answer.multi_select ? pre_req_answer.selIndexes : [pre_req_answer.selectedIndex])
                            : [];
                        if (!rule.ans_index.some((index) => pre_req_selections.includes(index))) {
                            skip_this_step = true;
                        }
                    }
                    break;
            }
        });
        if (skip_this_step) {
            if (nav_direction === NAV_DIRECTION.FORWARD) {
                step_skip_count_ref.current += 1;
                resetAnswers();
                questionNextAction(true);
            } else {
                step_skip_count_ref.current -= 1;
                questionPrevAction();
            }
        }
        let modified_subtitle_top = subtitle_top;
        modified_subtitle_top = linkifyText(modified_subtitle_top);
        setSubtitleTopHTML(modified_subtitle_top);
        setQuestionHTML(modified_question);
        setChoicesHTML(modified_choices);
        setInputQuestions(input_indices);
        setUnselectQuestions(unselect_indices);

        if (type === 'MTQ') {
            const existingOrder = Array.isArray(answers[question_number].selIndexes) && answers[question_number].selIndexes.length === choices.length
                ? answers[question_number].selIndexes
                : choices.map((_, idx) => idx);
            setMtqOrder(existingOrder);
            // Commit the default order as the answer so it's valid without requiring a drag.
            if (answers[question_number].selIndexes.length !== choices.length) {
                let _answers = answers;
                _answers[question_number].selIndexes = existingOrder;
                updateAnswers(_answers);
            }
        }

        // auto-taking test,
        if (enable_qa_mode && choices && choices.length > 1) {
            onChoiceClick(getRandomInt(0, choices.length - 1));
        }
    }, [question_number])

    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    const onChoiceClick = (index) => {
        let _answers = answers;
        if (type === 'YNQ') {
            index = (index+1) % choices.length;
        }
        if (_answers[question_number]) {
            if (_answers[question_number].multi_select) {

                let data = _answers[question_number].selIndexes;

                if (data.includes(index)) {
                    const _index = data.indexOf(index);
                    if (_index > -1) {
                        data.splice(_index, 1);
                    }
                    _answers[question_number].selIndexes = [...data];
                    updateAnswers(_answers);
                } else {
                    if(is_ui_rules_exist)
                    {
                        data = data.filter(val => !unselectQuestions.includes(val));
                        if(unselectQuestions.includes(index))
                        {
                            data = [];
                        }
                    }
                    else
                    {
                        data.map( choice => {
                            if (choices[choice].trim().toLowerCase().includes('none of the above') ||
                                choices[choice].trim().toLowerCase().includes('all of the above') ||
                                choices[choice].trim().toLowerCase().includes('해당하는 선택지 없음.')
                            ) {
                                const _index = data.indexOf(choice);
                                if (_index > -1) {
                                    data.splice(_index, 1);
                                }
                            }
                        })
                        if (choices[index].trim().toLowerCase().includes('none of the above') ||
                            choices[index].trim().toLowerCase().includes('all of the above') ||
                            choices[index].trim().toLowerCase().includes('해당하는 선택지 없음.')
                        ) {
                            data = [];
                        }
                    }
                    data.push(index);
                    _answers[question_number].selIndexes = [...data];
                    updateAnswers(_answers);
                }
            } else {
                let selectedIndex = _answers[question_number].selectedIndex;
                if (selectedIndex === index) {
                    _answers[question_number].selectedIndex = -1;
                    updateAnswers(_answers);
                } else {
                    _answers[question_number].selectedIndex = index;
                    updateAnswers(_answers);
                }
            }
        }
        // auto-next question after choice-click
        if (enable_qa_mode) questionNextAction();
    }

    const onChoiceInputChange = (index, event) => {
        let _answers = answers;
        _answers[question_number].custom_input = event.target.value;
        if(event.target.value === '')
        {
            if(_answers[question_number].multi_select)
            {
                const _index = _answers[question_number].selIndexes.indexOf(index);
                if(_index !== -1)
                {
                    _answers[question_number].selIndexes.splice(_index, 1)
                }
            }
            else
            {
                if(_answers[question_number].selectedIndex === index)
                {
                    _answers[question_number].selectedIndex = -1;
                }
            }
        }
        else
        {
            if(_answers[question_number].multi_select)
            {
                if(is_ui_rules_exist) {
                    _answers[question_number].selIndexes = _answers[question_number].selIndexes.filter(val => !unselectQuestions.includes(val));
                }
                const _index = _answers[question_number].selIndexes.indexOf(index);
                if(_index === -1)
                {
                    _answers[question_number].selIndexes.push(index)
                }
            }
            else
            {
                _answers[question_number].selectedIndex = index;
            }
        }
        updateAnswers(_answers);
    }

    const checkIfSelected = (index) => {
        let _answers = answers;
        if (type === 'YNQ') {
            index = (index+1) % choices.length;
        }
        if (_answers[question_number]) {
            if (_answers[question_number].multi_select) {
                return _answers[question_number].selIndexes.includes(index);
            } else {
                return index === _answers[question_number].selectedIndex;
            }
        }
    }

    const answerColor = (index) => {
        // Legacy: solid-fill selected state (white text on solid accent bg).
        // return checkIfSelected(index) ? '#fff' : '#000';
        // Unified list: bold accent-coloured text on a light tint when selected.
        return checkIfSelected(index) ? getActiveThemeColor(profile) : '#111827';
    }

    const answerBgColor = (index) => {
        // Legacy: solid-fill selected state.
        // return checkIfSelected(index) ? getActiveThemeColor(profile) : '';
        // Unified list: a light tint of the accent colour instead of a solid fill.
        return checkIfSelected(index) ? `${getActiveThemeColor(profile)}14` : '#ffffff';
    }

    const answerBorderColor = (index) => {
        // Legacy border was always solid-accent-coloured, selected or not
        // (see inline `border: '2px solid ' + getActiveThemeColor(profile)` below,
        // now superseded by this helper for the unified list).
        return checkIfSelected(index) ? getActiveThemeColor(profile) : '#E5E7EB';
    }

    const onHoverTooltip = (event, text) => {
        setToolTipPos({x: event.pageX, y: event.pageY})
        setToolTipText(text);
        setDisplayTooltip(true);
    }

    const onExitHoverTooltip = () => {
        setToolTipPos({x: 0, y: 0})
        setDisplayTooltip(false);
    }

    // Dragging is driven off window-level pointer listeners (rather than
    // element-level onPointerMove/Up + setPointerCapture) so the gesture keeps
    // tracking no matter where on the row the drag started from.
    const handleMtqPointerDown = (event, optionIdx) => {
        event.preventDefault();

        const itemEl = mtqItemRefs.current[optionIdx];
        const itemHeight = (itemEl ? itemEl.offsetHeight : 60) + 12; // row height + gap

        mtqDragMetaRef.current = { startClientY: event.clientY, itemHeight };
        setMtqDraggingIdx(optionIdx);
        setMtqDragOffsetY(0);
    }

    useEffect(() => {
        if (mtqDraggingIdx === null) return undefined;

        const handleMove = (event) => {
            const meta = mtqDragMetaRef.current;
            if (!meta) return;
            event.preventDefault();

            const rawOffset = event.clientY - meta.startClientY;
            const steps = Math.round(rawOffset / meta.itemHeight);

            if (steps !== 0) {
                setMtqOrder(prevOrder => {
                    const currentPos = prevOrder.indexOf(mtqDraggingIdx);
                    if (currentPos === -1) return prevOrder;

                    const targetPos = Math.min(Math.max(currentPos + steps, 0), prevOrder.length - 1);
                    if (targetPos === currentPos) return prevOrder;

                    const displacedItemIdx = prevOrder[targetPos];
                    const newOrder = [...prevOrder];
                    newOrder.splice(currentPos, 1);
                    newOrder.splice(targetPos, 0, mtqDraggingIdx);
                    meta.startClientY += steps * meta.itemHeight;

                    let _answers = answers;
                    _answers[question_number].selIndexes = newOrder;
                    updateAnswers(_answers);
                    setMtqDisplacedIdx(displacedItemIdx);

                    return newOrder;
                });
            }

            setMtqDragOffsetY(event.clientY - meta.startClientY);
        };

        const handleUp = () => {
            setMtqDraggingIdx(null);
            setMtqDragOffsetY(0);
            setMtqDisplacedIdx(null);
            mtqDragMetaRef.current = null;
        };

        window.addEventListener('pointermove', handleMove);
        window.addEventListener('pointerup', handleUp);
        window.addEventListener('pointercancel', handleUp);

        return () => {
            window.removeEventListener('pointermove', handleMove);
            window.removeEventListener('pointerup', handleUp);
            window.removeEventListener('pointercancel', handleUp);
        };
    }, [mtqDraggingIdx, question_number]);

    const QuizTimeContainer = styled.div`
        font-family: ${(props) => {
            switch (props.theme.name) {
                case DQ_THEMES.DEFAULT:
                    return `"${props.theme.fonts[0]}", "${props.theme.fonts[1]}"`;
                case DQ_THEMES.NUS_THEME:
                    return `"${props.theme.fonts[4]}"`;
                default:
                    return '';
            }
        }};
    `
    const QuizAnswer = styled.span`
        font-family: ${(props) => {
            switch (props.theme.name) {
                case DQ_THEMES.DEFAULT:
                    return `"${props.theme.fonts[0]}", "${props.theme.fonts[1]}"`;
                case DQ_THEMES.NUS_THEME:
                    return `"${props.theme.fonts[4]}"`;
                default:
                    return '';
            }
        }};
        display: block;
        padding: 10px;
        margin: 5px 0;
        cursor: pointer;
    `

    const formatMatchingQuestion = (html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const textContent = tempDiv.textContent || '';
        const lines = textContent.split('\n').map(line => line.trim()).filter(Boolean);
        const instruction = lines[0];

        // Variables to hold labels and list items
        let label1 = '';
        let label2 = '';
        const numberedItems = [];
        const letteredItems = [];

        let currentSection = '';

        for (let i = 1; i < lines.length; i++) {
            const line = lines[i];

            // Check for section label (no punctuation at the end and not a list item)
            if (!/^\d+\./.test(line) && !/^[A-Z]\./.test(line) && !line.endsWith('.') && line.length < 50) {
                currentSection = line.replace(/:$/, '').trim(); // Remove colon if present
            } else if (/^\d+\./.test(line)) {
                if (!label1) label1 = currentSection || '';
                numberedItems.push(line.replace(/^\d+\.\s*/, '').trim());
            } else if (/^[A-Z]\./.test(line)) {
                if (!label2) label2 = currentSection || '';
                letteredItems.push(line.replace(/^[A-Z]\.\s*/, '').trim());
            }
        }

        return (
            <div style={{textAlign: 'left', lineHeight: 1.3, maxWidth: '100%', margin: 0,}}>
                {/* Instruction */}
                {instruction && (
                    <div style={{ fontWeight: 700, marginBottom: 12 }}>
                        {instruction}
                    </div>
                )}

                {/* Numbered List Section */}
                {numberedItems.length > 0 && (
                    <div style={{ textAlign: 'left', marginBottom: 16 }}>
                        {label1 && (
                        <div style={{ fontWeight: 600, marginBottom: 6 }}>
                            {label1}:
                        </div>
                        )}
                        <div style={{ marginLeft: '50px' }}>
                            {numberedItems.map((item, idx) => (
                                <div key={`num-${idx}`} style={{ minWidth: "auto" }}>
                                    {`${idx + 1}. ${item}`}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Lettered List Section */}
                {letteredItems.length > 0 && (
                    <div style={{ textAlign: 'left', marginBottom: 16 }}>
                        {label2 && (
                        <div style={{ fontWeight: 600, marginBottom: 6 }}>
                            {label2}:
                        </div>
                        )}
                        <div style={{ marginLeft: '50px' }}>
                            {letteredItems.map((item, idx) => (
                                <div key={`let-${idx}`} style={{ minWidth: "auto" }}>
                                    {`${String.fromCharCode(65 + idx)}. ${item}`}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '30px', marginBottom: 'auto', paddingTop: 24 }}>
            <div className="qt-tooltip-content" style={{opacity: displayTooltip ? 100 : 0, backgroundColor: getActiveThemeColor(profile), top: tooltipPos.y, left: tooltipPos.x}}>
                {ReactHtmlParser(toolTipText)}
            </div>
            <div className={'qt-question-container'}>
                {/* Client-portal header row: number block | subtitle + question | raaz ring */}
                <div className={'qt-question-header-row'} style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    {/* Question number block */}
                    <div className={'qt-question-number-block'} style={{
                        flexShrink: 0, textAlign: 'center',
                        borderRight: '2px solid #E5E7EB',
                        alignSelf: 'stretch', display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    }}>
                        <div className={'qt-question-number-label'} style={{ fontWeight: 800, letterSpacing: '1px', textTransform: 'uppercase', color: '#9CA3AF' }}>
                            Question
                        </div>
                        <div className={'qt-question-number-value'} style={{ fontWeight: 800, lineHeight: 1, color: getActiveThemeColor(profile) }}>
                            {displayNumber != null ? String(displayNumber).padStart(2, '0') : ''}
                        </div>
                        <div className={'qt-question-number-total'} style={{ color: '#9CA3AF' }}>
                            of {totalQuestions != null ? totalQuestions : ''}
                        </div>
                    </div>

                    {/* Subtitle + question */}
                    <QuizTimeContainer
                        className={`qt-question-content qt-font-${parseInt((tips_length+question.length)/50)}`}
                        style={{ flex: 1, minWidth: 0, textAlign: 'left' }}
                    >
                        {
                            subtitle_top.length > 0 && <div
                                    style={{
                                    color: getActiveThemeColor(profile),
                                    backgroundColor: '#f1f6fd',
                                    fontSize: '1.1rem',
                                    fontWeight: 700,
                                    marginBottom: 10,
                                    display: 'inline-block',
                                    padding: '6px 14px',
                                    borderRadius: '999px',
                                }}
                                className={'qt-question-tips'} >
                                <span>{ReactHtmlParser(subtitleTopHTML)}</span>
                            </div>
                        }
                        <div className="qt-question-body" style={{ color: '#111827' }}>
                            {formatMatchingQuestion(questionHTML)}
                        </div>

                        {/* Subtitle Bottom */}
                        {
                            subtitle_bottom.length > 0 && <div
                                // pre-line keeps the sheet's line breaks (one "•" item
                                // per line), as the dq-seal-client preview renders it.
                                style={{color: '#666666', fontSize: '1.1rem', fontWeight: 700, marginTop: 8, whiteSpace: 'pre-line'}}
                                className={`qt-question-tips stb-font-${parseInt((subtitle_bottom.length)/50)}`} >
                                <span>{ReactHtmlParser(subtitle_bottom)}</span>
                            </div>
                        }
                    </QuizTimeContainer>

                    {/* Circular raaz progress ring */}
                    <div className={'qt-question-progress-ring'} style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div className={'qt-question-progress-ring-circle'} style={{ position: 'relative' }}>
                            <svg className={'qt-question-progress-svg'} viewBox="0 0 84 84">
                                <circle cx="42" cy="42" r="38" fill="none" stroke="#EDEDED" strokeWidth="4" />
                                <circle
                                    cx="42" cy="42" r="38" fill="none"
                                    stroke={getActiveThemeColor(profile)} strokeWidth="4" strokeLinecap="round"
                                    strokeDasharray={2 * Math.PI * 38}
                                    strokeDashoffset={2 * Math.PI * 38 * (1 - Math.min(Math.max(progress || 0, 0), 100) / 100)}
                                    transform="rotate(-90 42 42)"
                                />
                            </svg>
                            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <RazProgressSVG
                                    color={getActiveThemeColor(profile)}
                                    style={{ position: 'static', left: 'auto', top: 'auto', width: 'var(--qt-raaz-icon-size, 46px)', height: 'var(--qt-raaz-icon-size, 46px)' }}
                                />
                            </div>
                        </div>
                        <div className={'qt-question-progress-percent'} style={{ fontWeight: 700, color: getActiveThemeColor(profile), marginTop: 4 }}>
                            {Math.round(progress || 0)}%
                        </div>
                    </div>
                </div>
            </div>

            {
                type === 'GTQ' ?
                    <BalloonGamePoster
                        choices={choices}
                        onChoiceClick={onChoiceClick}
                        questionNextAction={questionNextAction}
                    />
                    :
                    <div
                        ref={choicesDiv}
                     className={`qt-answer-container ${type === 'LSQ' && choices.length === 7 ? ' qt-lsq-7' : ''} qt-${type.toLowerCase()} qt-opt-${choices.length} qt-theme-${settings.theme.toLowerCase()}${
                         // Unified list applies to the clickable-options branch only —
                         // LSQ/TFQ slider mode (choices.length === -1) keeps its own
                         // bespoke widget layout, untouched.
                         (type === 'LSQ' || type === 'TFQ') && choices.length === -1 ? '' : ' qt-unified-list'
                     }`}>
                        {
                           type === 'LSQ' && choices.length === -1 ?
                               <>
                                   <LSQSliderPoster
                                       choices={choices}
                                       onChoiceClick={onChoiceClick}
                                   />
                                   <Footer />
                               </>
                               :
                            type === 'TFQ' && choices.length === -1 ?
                                <>
                                    <TFQSliderPoster
                                        choices={choices}
                                        onChoiceClick={onChoiceClick}
                                    />
                                </>
                            :
                            type === 'MTQ' ?
                                <>
                                    <div className={'qt-mtq-hint'}>Drag and drop to order</div>
                                    {
                                        mtqOrder.map((optionIdx) => {
                                            const dragging = mtqDraggingIdx === optionIdx;
                                            const displaced = !dragging && mtqDisplacedIdx === optionIdx;
                                            const themeColor = getActiveThemeColor(profile);

                                            return (
                                                <div
                                                    key={optionIdx}
                                                    ref={(el) => { if (el) mtqItemRefs.current[optionIdx] = el; }}
                                                    className={`qt-answer-span qt-mtq-item${dragging ? ' qt-mtq-dragging' : ''}`}
                                                    style={{
                                                        '--qt-mtq-hover-border': themeColor,
                                                        border: '2px solid ' + (dragging ? themeColor : '#E5E7EB'),
                                                        backgroundColor: dragging || displaced ? `${themeColor}14` : '#ffffff',
                                                        color: '#111827',
                                                        transform: dragging ? `translateY(${mtqDragOffsetY}px)` : undefined,
                                                    }}
                                                    onPointerDown={(e) => handleMtqPointerDown(e, optionIdx)}
                                                >
                                                    <span className={'qt-mtq-drag-handle'}>
                                                        <span /><span /><span /><span /><span /><span />
                                                    </span>
                                                    <span>{choices[optionIdx]}</span>
                                                </div>
                                            );
                                        })
                                    }
                                </>
                            :
                                <>
                                {
                                    choices.map( (choice, index) => inputQuestions.includes(index) ? <input
                                        type="text"
                                        name="choice"
                                        placeholder={choice}
                                        value={answers[question_number] ? answers[question_number].custom_input : ''}
                                        style={{
                                            // Legacy: border: '2px solid ' + getActiveThemeColor(profile),
                                            border: '2px solid ' + answerBorderColor(index),
                                            color: answerColor(index),
                                            backgroundColor: answerBgColor(index),

                                        }}
                                        className={'qt-answer-span'}
                                        onChange={(event) => {onChoiceInputChange(index, event)}}
                                    /> :
                                        <QuizAnswer
                                                key={index}
                                        style={{
                                            // Legacy: border: '2px solid ' + getActiveThemeColor(profile),
                                            border: '2px solid ' + answerBorderColor(index),
                                            color: answerColor(index),
                                            backgroundColor: answerBgColor(index)
                                        }}
                                        className={'qt-answer-span'}
                                        onClick={() => {onChoiceClick(index)}}
                                    >
                                                {/* Letter badge (A, B, C…) — matches the client-portal option layout. */}
                                                <span
                                                    className={'qt-answer-letter'}
                                                    style={{
                                                        flexShrink: 0,
                                                        width: 34,
                                                        height: 34,
                                                        borderRadius: '50%',
                                                        marginRight: 14,
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontWeight: 700,
                                                        fontSize: 14,
                                                        border: checkIfSelected(index) ? 'none' : '1.5px solid #D1D5DB',
                                                        background: checkIfSelected(index) ? getActiveThemeColor(profile) : 'transparent',
                                                        color: checkIfSelected(index) ? '#fff' : '#6B7280',
                                                    }}
                                                >
                                                    {String.fromCharCode(65 + index)}
                                                </span>
                                                {choice.includes('<tooltip') ? (
                                                    ReactHtmlParser(choice, {
                                                        transform: (node) => {
                                                            if (node.type === 'tag' && node.name === 'tooltip') {
                                                                return (
                                                                    <span
                                                                        className="qt-tooltip"
                                                                        onMouseEnter={(e) => onHoverTooltip(e, node.attribs.html)}
                                                                        onMouseLeave={onExitHoverTooltip}
                                                                        style={{textDecoration: "underline"}}>{node.attribs.text}
                                                                     </span>
                                                                );
                                                            }
                                                            return undefined;
                                                        },
                                                    })
                                                ) : (
                                                    choice
                                                )}
                                                {/* Checkmark — new affordance for the unified list's selected state. */}
                                                {checkIfSelected(index) && (
                                                    <i
                                                        className="fa fa-check-circle qt-answer-checkmark"
                                                        style={{ color: getActiveThemeColor(profile) }}
                                                    />
                                                )}
                                    </QuizAnswer>
                                            )
                                }
                                {/* <div className="qt-white-mask-top"></div>
                                <div className="qt-white-mask-bot"></div> */}
                                </>
                        }
                </div>
            }

        </div>

    )
};

export default QuestionPoster;
